import { BrowserRouter, Route, Routes} from "react-router-dom";
import Dashboard from "./pages/dashboard/dashboard";
import Clientes from "./pages/clientes/clientes";
import Abertura from "./pages/abertura/abertura";

function Rotas(){
    return<BrowserRouter>
        <Routes>
            <Route path="/" element={<Dashboard/>} />
            <Route path="/dashboard" element={<Dashboard/>} />
            <Route path="/clientes" element={<Clientes/>} />
            <Route path="/abertura" element={<Abertura/>} />
        </Routes>
    </BrowserRouter>
}

export default Rotas;